/**
 * CustomPrice entity class
 */

/**
 * CustomPriceFactory
 * returns CustomPrice entity class
 *
 * @class CustomPriceFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.CustomPrice} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CustomPriceFactory
 */
/* @ngInject */
export default function CustomPriceFactory (Entity) {
  /* === CustomPrice class === */

  /**
   * CustomPrice model
   *
   * @class CustomPrice
   * @classdesc CustomPrice model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing CustomPrice entity fields
   * @return {models.CustomPrice} CustomPrice entity
   */
  function CustomPrice () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  CustomPrice.prototype = Object.create(Entity.prototype)
  CustomPrice.prototype.constructor = CustomPrice

  /* === CustomPrice instance methods & fields === */

  Object.assign(CustomPrice.prototype, {

    /**
     * instance fields
     *
     * @memberof models.CustomPrice#
     * @type {Object}
     */
    _fields: {
      vodId: Number,
      vodName: String,
      amount: Number,
      $vod: null
    },

    /**
     * Prepare object
     *
     * @memberof models.CustomPrice#
     * @override
     */
    _prepare: function () {
      if (this.vodId && this.vodName) {
        this.$vod = {
          id: this.vodId,
          name: this.vodName
        }
      }
    },

    /**
     * Get underlying object
     *
     * @memberof models.CustomPrice#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.vodId = this.$vod.id
      this.vodName = this.$vod.name

      let ret = Entity.prototype._object.apply(this, arguments)

      return ret
    }
  })

  /* === CustomPrice static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(CustomPrice, Entity)
  CustomPrice._name = 'CustomPrice'
  CustomPrice.init()

  // permissions
  CustomPrice.access = {}

  return CustomPrice
}
